import { NAV } from 'chatspot-core/types/LayoutVariants';
import styled from 'foundations-theming-specialty/utils';
import { useHostAppContext } from '../hostAppContext/hooks/useAppContext';
import { jsx as _jsx } from "react/jsx-runtime";
const BreezeSidebarBorderWrapper = styled.div.withConfig({
  displayName: "Layout__BreezeSidebarBorderWrapper",
  componentId: "s05r0b-0"
})(["padding:0px;height:100vh;width:100%;", ""], ({
  variant,
  isPreviewMode,
  theme
}) => variant !== NAV && !isPreviewMode && `
    background:
      linear-gradient(${theme.color['fill-surface-default']}, ${theme.color['fill-surface-default']}, ${theme.color['fill-surface-default']}) padding-box,
      ${theme.color['breeze-fill-special-btn-alt-default']} border-box;
    border-radius: ${theme.borderRadius['400']};
    border: ${theme.borderWidth['100']} solid transparent;
    @media (max-width: 400px) {
      border-radius: ${theme.borderRadius['100']};
      border: ${theme.borderWidth['100']} solid transparent;
  }
  `);
const ApplicationWrapper = styled.div.withConfig({
  displayName: "Layout__ApplicationWrapper",
  componentId: "s05r0b-1"
})(["border-radius:", ";align-self:stretch;flex:1 1 auto;height:100%;min-height:", ";"], ({
  theme
}) => theme.borderRadius['400'], ({
  theme
}) => theme.space['0']);
const Layout = ({
  children
}) => {
  const {
    variant,
    isPreviewMode
  } = useHostAppContext();
  return /*#__PURE__*/_jsx(BreezeSidebarBorderWrapper, {
    variant: variant,
    isPreviewMode: isPreviewMode,
    children: /*#__PURE__*/_jsx(ApplicationWrapper, {
      children: children
    })
  });
};
export default Layout;